<template>
	<div class="wrap" :class="{ 'wrap--embedded': embedded }">
		<myHead v-if="!embedded"></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu v-if="!embedded" num="1341"></ucMenu>
					<div class="right_con">
						<div class="record_main">
							<el-card shadow="never" style="min-height:650px;">
								<!-- 页面头部 -->
								<div class="page_header">
									<span class="back_btn" @click="goBack"><i class="el-icon-arrow-left"></i> 返回</span>
									<span class="page_title">微信小店数据分析</span>
									<div class="shop_selector">
										<span class="filter_label">店铺：</span>
										<el-select v-model="currentShopId" placeholder="请选择店铺" size="small" style="width:200px" filterable @change="handleShopChange">
											<el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
										</el-select>
									</div>
								</div>

								<!-- 全局筛选：时间 -->
								<div class="filter_bar">
									<div class="filter_item">
										<span class="filter_label">时间：</span>
										<span class="time_tag" :class="{active: timeSelectId === item.id}" v-for="item in timeOptions" :key="item.id" @click="timeTagClick(item)">{{item.name}}</span>
										<el-date-picker
											v-model="displayDateRange"
											type="daterange"
											range-separator="-"
											size="small"
											value-format="yyyy-MM-dd"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:picker-options="datePickerOptions"
											@change="customDateChange"
											style="width:240px;margin-left:10px;">
										</el-date-picker>
									</div>
								</div>

								<!-- 一级标签 -->
								<div class="main_tabs">
									<span class="main_tab" :class="{active: mainTab === 'transaction'}" @click="switchMainTab('transaction')">成交数据</span>
									<span class="main_tab" :class="{active: mainTab === 'refund'}" @click="switchMainTab('refund')">退款数据</span>
								</div>

								<!-- 二级标签 -->
								<div class="sub_tabs">
									<span class="sub_tab" v-for="tab in currentSubTabs" :key="tab.key"
										:class="{active: subTab === tab.key}" @click="switchSubTab(tab.key)">
										{{tab.label}}
									</span>
								</div>

								<!-- 数据区域 -->
								<div class="data_content" v-loading="loading">
									<!-- 成交概览 - 卡片视图 -->
									<div v-if="subTab === '1'" class="data_section">
										<div class="card_section">
											<div class="card_section_header">
												<div class="card_section_title">交易指标</div>
											</div>
											<div class="income_expense_cards">
												<div class="income_expense_card" v-for="field in overviewFields.slice(0, 7)" :key="field.key">
													<div class="card_label">{{field.label}}</div>
													<div class="card_value">{{formatValue(getSummaryData(field.key), field.fmt)}}</div>
												</div>
											</div>
										</div>
										<div class="card_section">
											<div class="card_section_header">
												<div class="card_section_title">退款指标</div>
											</div>
											<div class="income_expense_cards">
												<div class="income_expense_card" v-for="field in overviewFields.slice(7, 9)" :key="field.key">
													<div class="card_label">{{field.label}}</div>
													<div class="card_value">{{formatValue(getSummaryData(field.key), field.fmt)}}</div>
												</div>
											</div>
										</div>
										<div class="card_section">
											<div class="card_section_header">
												<div class="card_section_title">流量指标</div>
											</div>
											<div class="income_expense_cards">
												<div class="income_expense_card" v-for="field in overviewFields.slice(9)" :key="field.key">
													<div class="card_label">{{field.label}}</div>
													<div class="card_value">{{formatValue(getSummaryData(field.key), field.fmt)}}</div>
												</div>
											</div>
										</div>
									</div>

									<!-- 成交分析 - 表格视图 -->
									<div v-if="subTab === '18'" class="data_section">
										<el-table :data="getTableData('18')" border size="small" style="width:100%;margin-top:15px;">
											<el-table-column v-for="col in transactionColumns" :key="col.key"
												:prop="col.key" :label="col.label" :width="col.width" :min-width="col.minWidth"
												:align="col.align || 'center'">
												<template slot-scope="scope">
													<span>{{formatValue(scope.row[col.key], col.fmt)}}</span>
												</template>
											</el-table-column>
										</el-table>
									</div>

									<!-- 退款分析 - 表格视图 -->
									<div v-if="['19', '20', '21'].includes(subTab)" class="data_section">
										<el-table :data="getTableData(subTab)" border size="small" style="width:100%;margin-top:15px;">
											<el-table-column v-for="col in getRefundColumns(subTab)" :key="col.key"
												:prop="col.key" :label="col.label" :width="col.width" :min-width="col.minWidth"
												:align="col.align || 'center'">
												<template slot-scope="scope">
													<span>{{formatValue(scope.row[col.key], col.fmt)}}</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot v-if="!embedded"></myFoot>
	</div>
</template>

<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import { mapActions } from "vuex";

// 成交数据子标签
const transactionSubTabs = [
	{ key: '1', label: '成交概览' },
	{ key: '18', label: '成交分析' },
];

// 退款数据子标签
const refundSubTabs = [
	{ key: '19', label: '退款分析-全部' },
	{ key: '20', label: '退款分析-退款' },
	{ key: '21', label: '退款分析-退货退款' },
];

// 成交概览字段
const overviewFields = [
	{ key: 'income_amt', label: '成交金额', fmt: 'money' },
	{ key: 'net_pay_cnt', label: '成交订单数', fmt: 'num' },
	{ key: 'net_pay_ucnt', label: '成交人数', fmt: 'num' },
	{ key: 'pay_amt', label: '下单金额', fmt: 'money' },
	{ key: 'pay_cnt', label: '下单订单数', fmt: 'num' },
	{ key: 'pay_ucnt', label: '下单人数', fmt: 'num' },
	{ key: 'per_user_price', label: '客单价', fmt: 'money' },
	{ key: 'refund_amt', label: '退款金额', fmt: 'money' },
	{ key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money' },
	{ key: 'product_click_ucnt', label: '商品点击人数', fmt: 'bignum' },
];

// 成交分析表格列
const transactionColumns = [
	{ key: 'statistical_time', label: '时间', width: 100, fmt: 'text' },
	{ key: 'income_amt', label: '成交金额', fmt: 'money', minWidth: 110 },
	{ key: 'net_pay_cnt', label: '成交订单数', fmt: 'num' },
	{ key: 'net_pay_ucnt', label: '成交人数', fmt: 'num' },
	{ key: 'pay_amt', label: '下单金额', fmt: 'money', minWidth: 110 },
	{ key: 'pay_cnt', label: '下单订单数', fmt: 'num' },
	{ key: 'pay_ucnt', label: '下单人数', fmt: 'num' },
	{ key: 'refund_amt', label: '退款金额', fmt: 'money' },
	{ key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money', minWidth: 110 },
	{ key: 'per_user_price', label: '客单价', fmt: 'money' },
];

// 退款分析-全部 表格列
const refund19Columns = [
	{ key: 'statistical_time', label: '时间', width: 100, fmt: 'text' },
	{ key: 'pay_refund_success_amt', label: '成交退款金额', fmt: 'money', minWidth: 110 },
	{ key: 'pay_refund_success_ocnt', label: '成交退款订单数', fmt: 'num', minWidth: 120 },
	{ key: 'pay_refund_success_ucnt', label: '成交退款人数', fmt: 'num', minWidth: 110 },
	{ key: 'pay_refund_success_pcnt', label: '成交退款商品数', fmt: 'num', minWidth: 120 },
	{ key: 'pay_refund_success_uv_rate', label: '成交退款率', fmt: 'rate' },
];

// 退款分析-退款 表格列
const refund20Columns = [
	{ key: 'statistical_time', label: '时间', width: 100, fmt: 'text' },
	{ key: 'ship_before_refund_amt', label: '发货前退款金额', fmt: 'money', minWidth: 120 },
	{ key: 'ship_before_refund_ocnt', label: '发货前退款订单数', fmt: 'num', minWidth: 130 },
	{ key: 'ship_before_refund_ucnt', label: '发货前退款人数', fmt: 'num', minWidth: 120 },
	{ key: 'ship_before_refund_rate', label: '发货前退款率', fmt: 'rate', minWidth: 110 },
	{ key: 'ship_after_noreceive_refund_amt', label: '发货后退款金额', fmt: 'money', minWidth: 120 },
	{ key: 'ship_after_noreceive_refund_ocnt', label: '发货后退款订单数', fmt: 'num', minWidth: 130 },
	{ key: 'ship_after_noreceive_refund_ucnt', label: '发货后退款人数', fmt: 'num', minWidth: 120 },
	{ key: 'ship_after_noreceive_refund_rate', label: '发货后退款率', fmt: 'rate', minWidth: 110 },
	{ key: 'refund_amt_rate', label: '退款金额占比', fmt: 'rate', minWidth: 110 },
	{ key: 'refund_cnt_rate', label: '退款订单数占比', fmt: 'rate', minWidth: 120 },
];

// 退款分析-退货退款 表格列
const refund21Columns = [
	{ key: 'statistical_time', label: '时间', width: 100, fmt: 'text' },
	{ key: 'ship_after_receive_b_refund_amt', label: '退货退款金额', fmt: 'money', minWidth: 110 },
	{ key: 'ship_after_receive_b_refund_ocnt', label: '退货退款订单数', fmt: 'num', minWidth: 120 },
	{ key: 'ship_after_receive_b_refund_ucnt', label: '退货退款人数', fmt: 'num', minWidth: 110 },
	{ key: 'ship_after_receive_b_refund_rate', label: '退货退款率', fmt: 'rate' },
	{ key: 'ship_after_receive_refund_amt_rate', label: '退货退款金额占比', fmt: 'rate', minWidth: 130 },
	{ key: 'ship_after_receive_refund_ocnt_rate', label: '退货退款订单数占比', fmt: 'rate', minWidth: 140 },
];

export default {
	name: "ucShopBoardDetailWechat",
	props: {
		embedded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: false,
			currentShopId: '',
			shopOptions: [],
			mainTab: 'transaction',
			subTab: '1',
			timeSelectId: 1,
			customDateRange: '',
			datePickerOptions: {
				onPick: ({ maxDate, minDate }) => {
					if (minDate && !maxDate) {
						this.selectingStartDate = minDate.getTime();
					}
				},
				disabledDate: (time) => {
					if (time.getTime() > Date.now()) {
						return true;
					}
					if (this.selectingStartDate) {
						const oneDay = 24 * 60 * 60 * 1000;
						const maxDays = 31;
						const minTime = this.selectingStartDate - maxDays * oneDay;
						const maxTime = this.selectingStartDate + maxDays * oneDay;
						return time.getTime() < minTime || time.getTime() > maxTime;
					}
					return false;
				}
			},
			selectingStartDate: null,
			searchData: {
				start_time: '',
				end_time: '',
			},
			timeOptions: [
				{ id: 1, name: '实时', day: 'realtime' },
				{ id: 2, name: '近1天', day: '1' },
				{ id: 3, name: '近7天', day: '7' },
				{ id: 4, name: '近30天', day: '30' },
			],
			apiData: {
				type18_data: [],
				type19_data: [],
				type20_data: [],
				type21_data: [],
				type22_data: null,
			},
			// 字段定义
			overviewFields: overviewFields,
			transactionColumns: transactionColumns,
			refund19Columns: refund19Columns,
			refund20Columns: refund20Columns,
			refund21Columns: refund21Columns,
		}
	},
	components: {
		myHead, myFoot, ucMenu
	},
	computed: {
		// 当前子标签列表
		currentSubTabs() {
			return this.mainTab === 'transaction' ? transactionSubTabs : refundSubTabs;
		},
		// 是否为实时数据
		isRealtimeData() {
			return this.timeSelectId === 1;
		},
		// 显示的日期范围
		displayDateRange: {
			get() {
				if (this.customDateRange && this.customDateRange.length === 2) {
					return this.customDateRange;
				}
				if (this.searchData.start_time && this.searchData.end_time) {
					return [this.searchData.start_time, this.searchData.end_time];
				}
				if (this.timeSelectId) {
					const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
					if (timeOption) {
						if (timeOption.day === 'realtime') {
							const today = this.formatDate(new Date());
							return [today, today];
						} else {
							const today = new Date();
							const days = parseInt(timeOption.day);
							const yesterday = new Date(today);
							yesterday.setDate(yesterday.getDate() - 1);
							const end = this.formatDate(yesterday);
							const start = new Date(yesterday);
							start.setDate(start.getDate() - (days - 1));
							const startDate = this.formatDate(start);
							return [startDate, end];
						}
					}
				}
				return '';
			},
			set(value) {
				this.customDateRange = value;
			}
		}
	},
	created() {
		// 从路由参数获取店铺ID
		const shopId = this.$route.query.id;
		if (shopId) {
			// 转换为数字类型以匹配 shop_id
			this.currentShopId = parseInt(shopId);
		}
		this.loadShopList();
		this.loadData();
	},
	methods: {
		...mapActions({
			getShopList: "shop_board/getShopList",
			getWechatShopDataDetail: "shop_board/getWechatShopDataDetail",
		}),
		// 返回列表页
		goBack() {
			// 使用浏览器返回，保持菜单状态
			this.$router.go(-1);
		},
		// 加载店铺列表
		loadShopList() {
			this.getShopList({
				data: { shop_type: 7,status:1}, // 只加载微信小店
				success: (res) => {
					if (res.code === 200 && res.data) {
						if (res.data.list && res.data.list.list) {
							this.shopOptions = res.data.list.list;
						} else if (Array.isArray(res.data.list)) {
							this.shopOptions = res.data.list;
						} else if (Array.isArray(res.data)) {
							this.shopOptions = res.data;
						} else {
							this.shopOptions = [];
						}

						// 确保 currentShopId 在店铺列表中存在
						if (this.currentShopId && this.shopOptions.length > 0) {
							const found = this.shopOptions.find(shop => shop.shop_id == this.currentShopId);
							if (found) {
								// 确保类型匹配
								this.currentShopId = found.shop_id;
							}
						}
					}
				}
			});
		},
		// 切换店铺
		handleShopChange(shopId) {
			this.currentShopId = shopId;
			this.loadData();
		},
		// 切换主标签
		switchMainTab(tab) {
			this.mainTab = tab;
			// 切换到对应的第一个子标签
			this.subTab = tab === 'transaction' ? '1' : '19';
		},
		// 切换子标签
		switchSubTab(key) {
			this.subTab = key;
		},
		// 时间标签点击
		timeTagClick(item) {
			this.timeSelectId = item.id;
			this.customDateRange = '';
			this.searchData.start_time = '';
			this.searchData.end_time = '';
			this.loadData();
		},
		// 自定义日期变更
		customDateChange() {
			this.selectingStartDate = null;
			if (this.customDateRange && this.customDateRange.length === 2) {
				const start = new Date(this.customDateRange[0]);
				const end = new Date(this.customDateRange[1]);
				const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
				if (diffDays > 31) {
					this.$message.warning('时间范围不能超过31天');
					this.customDateRange = '';
					return;
				}
				this.timeSelectId = '';
				this.searchData.start_time = this.customDateRange[0];
				this.searchData.end_time = this.customDateRange[1];
			} else {
				this.timeSelectId = 1;
				this.searchData.start_time = '';
				this.searchData.end_time = '';
			}
			this.loadData();
		},
		// 加载数据
		loadData() {
			if (!this.currentShopId) return;

			this.loading = true;

			const params = {
				mer_shop_id: this.currentShopId,
				start_date: this.searchData.start_time || this.displayDateRange[0],
				end_date: this.searchData.end_time || this.displayDateRange[1],
				is_realtime: this.isRealtimeData ? 1 : 0,
			};

			this.getWechatShopDataDetail({
				data: params,
				success: (res) => {
					this.loading = false;
					if (res.code === 200 && res.data) {
						this.apiData = res.data;
					} else {
						this.$message.error(res.msg || '获取数据失败');
					}
				},
				error: () => {
					this.loading = false;
				}
			});
		},
		// 获取汇总数据
		getSummaryData(key) {
			if (this.isRealtimeData && this.apiData.type22_data) {
				return this.apiData.type22_data[key];
			}
			// 历史数据：汇总 type18_data
			if (this.apiData.type18_data && this.apiData.type18_data.length > 0) {
				let sum = 0;
				this.apiData.type18_data.forEach(row => {
					const val = parseFloat(row[key]) || 0;
					sum += val;
				});
				// 客单价需要重新计算
				if (key === 'per_user_price') {
					const totalIncome = this.getSummaryData('income_amt');
					const totalUsers = this.getSummaryData('net_pay_ucnt');
					return totalUsers > 0 ? totalIncome / totalUsers : 0;
				}
				return sum;
			}
			return 0;
		},
		// 获取表格数据
		getTableData(type) {
			const key = `type${type}_data`;
			return this.apiData[key] || [];
		},
		// 获取退款列定义
		getRefundColumns(type) {
			if (type === '19') return this.refund19Columns;
			if (type === '20') return this.refund20Columns;
			if (type === '21') return this.refund21Columns;
			return [];
		},
		// 获取当前标签标题
		getCurrentTabLabel() {
			const allTabs = [...transactionSubTabs, ...refundSubTabs];
			const tab = allTabs.find(t => t.key === this.subTab);
			return tab ? tab.label : '';
		},
		// 格式化日期
		formatDate(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		// 格式化值
		formatValue(val, fmt) {
			if (val === undefined || val === null || val === '') return '--';
			if (fmt === 'money') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return '¥' + (n / 10000).toFixed(2) + '万';
				return '¥' + n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			}
			if (fmt === 'num') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return (n / 10000).toFixed(2) + '万';
				return n.toLocaleString('zh-CN');
			}
			if (fmt === 'bignum') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return (n / 10000).toFixed(1) + '万';
				return n.toLocaleString('zh-CN');
			}
			if (fmt === 'rate') {
				return String(val);
			}
			return val;
		},
	}
}
</script>

<style scoped>

.center {
	display: flex;
	flex: 1;
}
.wrap--embedded { min-width: 0; min-height: 0; background: transparent; }
.wrap--embedded .wrap_body { padding: 0; }
.wrap--embedded .center { width: 100%; min-width: 0; margin: 0; }
.wrap--embedded .ucenter_main { padding: 0; gap: 0; }
.wrap--embedded .right_con { width: 100%; background: transparent; }

.el-card__body {
	padding: 12px 20px;
}
.page_header {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #ebeef5;
}
.back_btn {
	cursor: pointer;
	color: #409eff;
	margin-right: 15px;
}
.back_btn:hover {
	color: #66b1ff;
}
.back_btn i {
	margin-right: 2px;
	font-size: 16px;
}
.page_title {
	font-size: 18px;
	font-weight: bold;
	color: #303133;
	flex: 1;
}
.shop_selector {
	display: flex;
	align-items: center;
}
.filter_bar {
	margin-bottom: 15px;
}
.filter_item {
	display: flex;
	align-items: center;
}
.filter_label {
	margin-right: 10px;
	color: #606266;
	font-size: 14px;
}
.time_tag {
	display: inline-block;
	padding: 5px 12px;
	margin-right: 8px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	cursor: pointer;
	font-size: 13px;
	color: #606266;
	transition: all 0.3s;
}
.time_tag:hover {
	color: #409eff;
	border-color: #c6e2ff;
	background-color: #ecf5ff;
}
.time_tag.active {
	color: #fff;
	background-color: #409eff;
	border-color: #409eff;
}
.main_tabs {
	display: flex;
	border-bottom: 2px solid #e4e7ed;
	margin-bottom: 20px;
}
.main_tab {
	padding: 10px 20px;
	cursor: pointer;
	font-size: 15px;
	color: #606266;
	border-bottom: 2px solid transparent;
	margin-bottom: -2px;
	transition: all 0.3s;
}
.main_tab:hover {
	color: #409eff;
}
.main_tab.active {
	color: #409eff;
	border-bottom-color: #409eff;
	font-weight: bold;
}
.sub_tabs {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 20px;
}
.sub_tab {
	padding: 6px 16px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	cursor: pointer;
	font-size: 13px;
	color: #606266;
	transition: all 0.3s;
}
.sub_tab:hover {
	color: #409eff;
	border-color: #c6e2ff;
	background-color: #ecf5ff;
}
.sub_tab.active {
	color: #fff;
	background-color: #409eff;
	border-color: #409eff;
}
.data_content {
	min-height: 400px;
}
.data_section {
	margin-bottom: 30px;
}
.section_title {
	font-size: 16px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 15px;
	padding-left: 10px;
	border-left: 3px solid #409eff;
}
.card_section {
	margin-bottom: 20px;
}
.card_section:last-child {
	margin-bottom: 0;
}
.card_section_header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
}
.card_section_title {
	font-size: 14px;
	font-weight: bold;
	color: #303133;
	padding: 8px 0;
	border-left: 3px solid #409EFF;
	padding-left: 10px;
}
.income_expense_cards {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}
.income_expense_card {
	flex: 0 0 auto;
	min-width: 160px;
	background: #fafbfc;
	border: 1px solid #ebeef5;
	border-radius: 6px;
	padding: 12px 14px;
	transition: all 0.3s;
}
.income_expense_card:hover {
	background: #ecf5ff;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card_label {
	font-size: 13px;
	color: #909399;
	margin-bottom: 8px;
}
.card_value {
	font-size: 20px;
	font-weight: bold;
	color: #303133;
}
</style>
